// TargetingSection.jsx
// Client: vmfive
// Version: 1.1.0
// Single-column accordion section for targeting dimensions
// Uses shared Toggle component

import './TargetingSection.css';
import Toggle from './Toggle';

export default function TargetingSection({
  title,
  icon,
  summary,
  enabled = false,
  onToggle,
  children,
  className = '',
}) {
  return (
    <div className={`targeting-section ${enabled ? 'targeting-section--enabled' : ''} ${className}`}>
      <div className="targeting-section__header" onClick={onToggle}>
        <div className="targeting-section__icon">{icon}</div>
        <div className="targeting-section__info">
          <h3 className="targeting-section__title">{title}</h3>
          {summary && (
            <p className="targeting-section__summary">{summary}</p>
          )}
        </div>
        <Toggle checked={enabled} onChange={onToggle} />
      </div>
      {enabled && (
        <div className="targeting-section__body">
          {children}
        </div>
      )}
    </div>
  );
}
